const UTM_STORAGE_KEY = 'signup-utm-attribution'
const MAX_UTM_VALUE_LENGTH = 255
const UTM_MAX_AGE_MS = 4 * 60 * 60 * 1000

const UTM_FIELDS = {
  utm_source: 'source',
  utm_medium: 'medium',
  utm_campaign: 'campaign',
  utm_term: 'term',
  utm_content: 'content'
}

const sanitizeUtmValue = value => {
  if (typeof value !== 'string') {
    return null
  }

  const trimmedValue = value.trim()
  if (!trimmedValue) {
    return null
  }

  return trimmedValue.slice(0, MAX_UTM_VALUE_LENGTH)
}

const extractUtmFromSearch = search => {
  const params = new URLSearchParams(search || '')
  const utm = {}

  Object.entries(UTM_FIELDS).forEach(([queryKey, payloadKey]) => {
    const value = sanitizeUtmValue(params.get(queryKey))

    if (value) {
      utm[payloadKey] = value
    }
  })

  return Object.keys(utm).length > 0 ? utm : null
}

const getStoredUtmData = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null
  }

  const rawStoredData = window.sessionStorage.getItem(UTM_STORAGE_KEY)
  if (!rawStoredData) {
    return null
  }

  try {
    return JSON.parse(rawStoredData)
  } catch (err) {
    window.sessionStorage.removeItem(UTM_STORAGE_KEY)
    return null
  }
}

export const clearCapturedUtm = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return
  }

  window.sessionStorage.removeItem(UTM_STORAGE_KEY)
}

export const captureUtmAttributionFromUrl = search => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null
  }

  const utm = extractUtmFromSearch(search || window.location.search)
  if (!utm) {
    return null
  }

  window.sessionStorage.setItem(
    UTM_STORAGE_KEY,
    JSON.stringify({
      capturedAt: Date.now(),
      utm
    })
  )

  return utm
}

export const getSignupUtmPayload = () => {
  const storedData = getStoredUtmData()
  if (!storedData || typeof storedData !== 'object') {
    return undefined
  }

  if (
    typeof storedData.capturedAt !== 'number' ||
    Date.now() - storedData.capturedAt > UTM_MAX_AGE_MS
  ) {
    clearCapturedUtm()
    return undefined
  }

  if (!storedData.utm || typeof storedData.utm !== 'object') {
    clearCapturedUtm()
    return undefined
  }

  const normalizedUtm = {}

  Object.values(UTM_FIELDS).forEach(payloadKey => {
    const value = sanitizeUtmValue(storedData.utm[payloadKey])

    if (value) {
      normalizedUtm[payloadKey] = value
    }
  })

  if (Object.keys(normalizedUtm).length === 0) {
    clearCapturedUtm()
    return undefined
  }

  return normalizedUtm
}
